export var ValidationError;
(function (ValidationError) {
    ValidationError[ValidationError["UNKNOWN"] = 0] = "UNKNOWN";
    ValidationError[ValidationError["NO_MATCH"] = 1] = "NO_MATCH";
    ValidationError[ValidationError["NO_MATCH_MULTIPLE"] = 2] = "NO_MATCH_MULTIPLE";
    ValidationError[ValidationError["BAD_REQUEST"] = 3] = "BAD_REQUEST";
    ValidationError[ValidationError["SERVICE_DISABLED"] = 4] = "SERVICE_DISABLED";
    ValidationError[ValidationError["IMEI_INVALID"] = 5] = "IMEI_INVALID";
    ValidationError[ValidationError["IMEI_NOT_PROCESSED"] = 6] = "IMEI_NOT_PROCESSED";
    ValidationError[ValidationError["UNKNOWN_DEVICE"] = 7] = "UNKNOWN_DEVICE";
    ValidationError[ValidationError["IMEI_HAS_ACTIVE_CONTRACT"] = 8] = "IMEI_HAS_ACTIVE_CONTRACT";
    ValidationError[ValidationError["IMEI_CONTRACT_VALIDATION_NOT_AVAILABLE"] = 9] = "IMEI_CONTRACT_VALIDATION_NOT_AVAILABLE";
    ValidationError[ValidationError["IMEI_HAS_FINANCIAL_CONTRACT"] = 10] = "IMEI_HAS_FINANCIAL_CONTRACT";
})(ValidationError || (ValidationError = {}));
export var Condition;
(function (Condition) {
    Condition[Condition["OK"] = 10] = "OK";
    Condition[Condition["BUTTONS_ISSUE"] = 40] = "BUTTONS_ISSUE";
    Condition[Condition["FRAME_DAMAGED"] = 50] = "FRAME_DAMAGED";
    Condition[Condition["SCREEN_GLASS_CRACKED"] = 60] = "SCREEN_GLASS_CRACKED";
    Condition[Condition["SCREEN_COLORS_OR_TOUCH_ISSUE"] = 70] = "SCREEN_COLORS_OR_TOUCH_ISSUE";
    Condition[Condition["NOT_TURNING_ON_OR_CHARGING"] = 90] = "NOT_TURNING_ON_OR_CHARGING";
    Condition[Condition["LAPTOP_NO_POWER"] = 135] = "LAPTOP_NO_POWER";
    Condition[Condition["LAPTOP_SCREEN_DAMAGE"] = 130] = "LAPTOP_SCREEN_DAMAGE";
    Condition[Condition["LAPTOP_BOOT_FAILS"] = 125] = "LAPTOP_BOOT_FAILS";
    Condition[Condition["LAPTOP_PHYSICAL_DAMAGE"] = 120] = "LAPTOP_PHYSICAL_DAMAGE";
    Condition[Condition["SMARTWATCH_POWER_OR_SCREEN_DAMAGE"] = 150] = "SMARTWATCH_POWER_OR_SCREEN_DAMAGE";
    Condition[Condition["SMARTWATCH_CHARGER_AND_BAND"] = 155] = "SMARTWATCH_CHARGER_AND_BAND";
})(Condition || (Condition = {}));
